import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2.569 1.45a1.219 1.219 0 1 1-2.438 0 1.219 1.219 0 0 1 2.438 0m1.92 0a1 1 0 0 1 1-1h1.303a1 1 0 0 1 0 2H5.49a1 1 0 0 1-1-1ZM.35 8.813a1 1 0 0 1 1-1h21.3a1 1 0 0 1 1 1v6.474a1 1 0 0 1-1 1H1.35a1 1 0 0 1-1-1zm2 1v4.474h5.173V9.813zm7.173 0v4.474h5.05V9.813zm12.127 4.474h-5.078V9.813h5.078zM11.349.45a1 1 0 1 0 0 2h1.302a1 1 0 1 0 0-2zm4.86 1a1 1 0 0 1 1-1h1.301a1 1 0 1 1 0 2h-1.302a1 1 0 0 1-1-1Zm-10.72 20.1a1 1 0 0 0 0 2h1.303a1 1 0 1 0 0-2H5.49Zm4.86 1a1 1 0 0 1 1-1h1.302a1 1 0 0 1 0 2h-1.302a1 1 0 0 1-1-1m6.86-1a1 1 0 0 0 0 2h1.301a1 1 0 1 0 0-2h-1.302ZM1.35 3.795a1 1 0 0 1 1 1v1.022a1 1 0 0 1-2 0V4.795a1 1 0 0 1 1-1m8.173 1a1 1 0 1 0-2 0v1.022a1 1 0 0 0 2 0zm6.05-1a1 1 0 0 1 1 1v1.022a1 1 0 1 1-2 0V4.795a1 1 0 0 1 1-1M2.35 18.375a1 1 0 1 0-2 0v1.022a1 1 0 1 0 2 0zm6.173-1a1 1 0 0 1 1 1v1.022a1 1 0 1 1-2 0v-1.022a1 1 0 0 1 1-1M23.65 4.795a1 1 0 0 0-2 0v1.022a1 1 0 1 0 2 0zm-8.078 12.58a1 1 0 0 1 1 1v1.022a1 1 0 1 1-2 0v-1.022a1 1 0 0 1 1-1m8.078 1a1 1 0 0 0-2 0v1.022a1 1 0 1 0 2 0zm-1-15.706a1.219 1.219 0 1 0 0-2.438 1.219 1.219 0 0 0 0 2.438M2.569 22.55a1.219 1.219 0 1 1-2.438 0 1.219 1.219 0 0 1 2.438 0m20.081 1.219a1.219 1.219 0 1 0 0-2.438 1.219 1.219 0 0 0 0 2.438",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const TableHeader = { render };
export {
  TableHeader as default,
  render
};
//# sourceMappingURL=TableHeader.svg.js.map
